var map = {
	"./aptitude/score-range-icons/custom-sr-aptitude.png": 924727,
	"./aptitude/score-range-icons/recommended-sr-aptitude.png": 173895,
	"./aptitude/score-report/aptitude-high-score-icon.png": 100905,
	"./aptitude/score-report/aptitude-low-score-icon.png": 419253,
	"./aptitude/score-report/aptitude-mid-score-icon.png": 967361,
	"./aptitude/score-report/aptitude-score-report-attention-to-detail-icon.png": 255666,
	"./aptitude/score-report/aptitude-score-report-icon.png": 818377,
	"./aptitude/score-report/aptitude-score-report-logic-analysis-icon.png": 853353,
	"./aptitude/score-report/aptitude-score-report-math-icon.png": 49204,
	"./aptitude/score-report/aptitude-score-report-number-reasoning-icon.png": 433478,
	"./aptitude/score-report/aptitude-score-report-spatial-icon.png": 729816,
	"./aptitude/score-report/aptitude-score-report-verbal-icon.png": 231990,
	"./aptitude/score-report/attention-icon.png": 873181,
	"./aptitude/score-report/divided-attention-icon.png": 459855,
	"./aptitude/score-report/filtering-icon.png": 161801,
	"./aptitude/score-report/information-ordering-icon.png": 885978,
	"./aptitude/score-report/logic-icon.png": 898333,
	"./aptitude/score-report/memory-icon.png": 32044,
	"./aptitude/score-report/reaction-time-icon.png": 257840,
	"./aptitude/score-report/reasoning-icon.png": 270895,
	"./aptitude/score-report/robot-inspector-icon.png": 408199,
	"./aptitude/score-report/spatial-memory-icon.png": 874563,
	"./aptitude/score-report/verbal-memory-icon.png": 123119,
	"./aptitude/score-report/vigilance-icon.png": 587755,
	"./aptitude/score-report/visualization-icon.png": 969387,
	"./aptitude/score-report/weigh-station-icon.png": 201978,
	"./aptitude/score-report/words-feather-icon.png": 625680,
	"./emotional/score-range-icons/custom-sr-emotional-intelligence.png": 597529,
	"./emotional/score-range-icons/recommended-sr-emotional.png": 906337,
	"./emotional/score-report/emotional-intelligence.png": 974117,
	"./emotional/score-report/managing-icon.png": 361251,
	"./emotional/score-report/perceiving-icon.png": 203023,
	"./emotional/score-report/understanding-icon.png": 928821,
	"./extended-badge.png": 677975,
	"./in-range-badge.png": 332681,
	"./personality/score-range-icons/custom-sr-personality.png": 477001,
	"./personality/score-range-icons/recommended-sr-personality.png": 448921,
	"./personality/score-report/NeedsAttention-icon.png": 584922,
	"./personality/score-report/PotentialStrengths-icon.png": 783147,
	"./personality/score-report/Strengths-icon.png": 830049,
	"./personality/score-report/achievement-icon.png": 889836,
	"./personality/score-report/agreeableness-icon.png": 194436,
	"./personality/score-report/assertiveness-icon.png": 836000,
	"./personality/score-report/competitiveness-icon.png": 895191,
	"./personality/score-report/conscientiousness-icon.png": 892250,
	"./personality/score-report/cooperativeness-icon.png": 281055,
	"./personality/score-report/criteria-score-range-icon.png": 532629,
	"./personality/score-report/cs-icon.png": 28945,
	"./personality/score-report/diplomacy-icon.png": 960985,
	"./personality/score-report/extroversion-icon.png": 480583,
	"./personality/score-report/inner-icon.png": 540139,
	"./personality/score-report/interpersonal-icon.png": 939337,
	"./personality/score-report/managerial-icon.png": 516664,
	"./personality/score-report/motivation-icon.png": 9051,
	"./personality/score-report/openness-icon.png": 488892,
	"./personality/score-report/patience-icon.png": 176544,
	"./personality/score-report/personality-score-report-icon.png": 131203,
	"./personality/score-report/relaxed-attitude-icon.png": 625987,
	"./personality/score-report/sales-icon.png": 216359,
	"./personality/score-report/self-confidence-icon.png": 517914,
	"./personality/score-report/stress-tolerance-icon.png": 201565,
	"./personality/score-report/work-icon.png": 725474,
	"./risk/score-range-icons/custom-sr-risk.png": 306021,
	"./risk/score-range-icons/recommended-sr-risk.png": 893183,
	"./risk/score-report/attitude-towards-theft-icon.png": 453257,
	"./risk/score-report/conscientiousness-icon.png": 989365,
	"./risk/score-report/integrity-honesty-icon.png": 280232,
	"./risk/score-report/integrity-icon.png": 257911,
	"./risk/score-report/perseverance-icon.png": 64017,
	"./risk/score-report/risk-score-report-icon.png": 211193,
	"./risk/score-report/work-habits-icon.png": 88347,
	"./skills/score-range-icons/custom-sr-skills.png": 588675,
	"./skills/score-range-icons/recommended-sr-skills.png": 194755,
	"./skills/score-report/check-circle.png": 427652,
	"./skills/score-report/clik-icon.png": 235564,
	"./skills/score-report/excel-icon.png": 728332,
	"./skills/score-report/listening.png": 10686,
	"./skills/score-report/math-and-logic.png": 176974,
	"./skills/score-report/ppt-icon.png": 208463,
	"./skills/score-report/reading.png": 556133,
	"./skills/score-report/skills-score-report-icon.png": 153869,
	"./skills/score-report/times.png": 617527,
	"./skills/score-report/tkt-icon.png": 301220,
	"./skills/score-report/tt-icon.png": 203343,
	"./skills/score-report/verbal-ability.png": 811416,
	"./skills/score-report/word-icon.png": 174771,
	"./skills/score-report/writing.png": 188197,
	"./testmaker/score-range-icons/custom-sr-testmaker.png": 901829,
	"./testmaker/score-report/testmaker-score-report-icon.png": 73311
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 489374;